import { RESET_PASSWORD, SEND_EMAIL } from "./reset.constants";

export const sendEmail = (callback) => ({type: SEND_EMAIL, callback})
export const resetPassword = (payload, callback) => ({type: RESET_PASSWORD, payload, callback})